import { Component, ViewChild } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoEmailInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-email-input',
  templateUrl: 'co-email-input.html'
})
export class CoEmailInputComponent {
  textInput: string;
  emailRegex: any;
  textValid: boolean = true;
  phoneRegex: any;
  inputType: string;
  placeholderText: string;
  inputHeaderText: string;
  submitButtonText: string = 'Send';
  @ViewChild('email') myInput;
  constructor(public viewCtrl: ViewController, private state: AppState, private navParams: NavParams, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    this.inputType = this.navParams.data.inputType || 'email';
    this.textInput = this.navParams.data.email || '';
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }
  ngOnInit() {
    switch (this.inputType) {
      case ('email'):
        (this.state.patron && this.state.patron.email && !this.state.staff)? this.textInput = this.state.patron.email : this.textInput = this.textInput;
        this.inputHeaderText = 'Type in email address';
        this.placeholderText = 'email';
        break;
      case ('phone'):
        (this.state.patron && this.state.patron.phone && !this.state.staff)? this.textInput = this.state.patron.phone : this.textInput = "";
        this.inputHeaderText = 'Enter phone number';
        this.placeholderText = 'cell number';
        break;
      case('barcode'):
        this.inputHeaderText = 'Type in barcode';
        this.placeholderText = 'barcode';
        this.submitButtonText = 'Done';
        break;
      default:
        this.textInput = "";
        this.inputHeaderText = 'text';
        this.placeholderText = '';
        break;
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  ionViewDidLoad() {
    setTimeout(() => {
      this.myInput.setFocus();
    }, 1000);
  }
  scrollToInput(event){
    // setTimeout(()=>event._elementRef.nativeElement.scrollIntoView({block: "center"}), 100);
  }
  close() {
    switch (this.inputType) {
      case ('email'):
        if (this.emailRegex.test(this.textInput)) {
          this.textValid = true;
          this.viewCtrl.dismiss({ info: this.textInput }).catch(err=>{});
        } else {
          this.textValid = false;
        }
        break;
      case ('phone'):
        if (this.phoneRegex.test(this.textInput)) {
          this.textValid = true;
          this.viewCtrl.dismiss({ info: this.textInput }).catch(err=>{});
        } else {
          this.textValid = false;
        }
      default :
        this.viewCtrl.dismiss({info: this.textInput}).catch(err=>{});
      break;
    }
  }

  cancel(){
    this.viewCtrl.dismiss().catch(err=>{});
  }

}



// WEBPACK FOOTER //
// ./src/components/co-email-input/co-email-input.ts